import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TStatus, TXmppState } from '../../types/xmpp';

export const xmppActionTypes = {
  CONNECTION_REQUEST: 'XMPP/CONNECTON_REQUEST',
  CONNECTION_SUCCESS: 'XMPP/CONNECTION_SUCCESS',
  SET_STATUS: 'XMPP/SET_STATUS',
} as const;

const initialState: TXmppState = {
  status: 'DISCONNECTED',
};

const xmppSlice = createSlice({
  name: 'xmpp',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<TStatus>) => ({
      ...state,
      status: action.payload,
    }),
    connectionRequest: (_, __: PayloadAction<{ username: string; password: string }>) => ({
      status: 'CONNECTING' as const,
    }),
    disconnectRequest: () => ({
      status: 'DISCONNECTING' as const,
    }),
  },
});

export const { actions, name, reducer } = xmppSlice;
export default xmppSlice;
